/* Nordic Weaving: opdateringstilstand i kurv-skuffen. Bygget 11/9-2026.

   HVORFOR DEN FINDES
   Trykker man Tilføj på et krydssalgskort i skuffen, bruger temaets ajax
   2,3 sekunder på at hente og flette den nye kurv ind. Målt 11/9 med 40 ms
   mellem hver måling:
     0 til 1060 ms  intet sker, temaet venter på /cart/add.js
     1264 ms        varelisten rummer TRE varer hvor der skal være to,
                    fordi temaet indsætter ny markup før den gamle fjernes
     1477 ms        .cart-item-list er 0 px høj mens krydssalget allerede
                    er tegnet igen
     2150 ms        alt på plads
   Med to varer i Gemt til senere hoppede den boks 514 px, og krydssalget
   krympede fra 515 til 184 px når dets kort blev filtreret.

   Vi kan ikke gøre temaets gentegning hurtigere, og vi kan ikke låse os ud
   af den, for blokkene skifter reelt størrelse. Så vi skjuler den: højden på
   hele overdelen holdes fast, og et sandfarvet dæk ligger over indholdet
   imens. Kunden ser "Opdaterer kurven" og derefter den færdige kurv.

   HVORFOR DEN LIGGER I SIN EGEN FIL OG IKKE I nw-kurv.js
   En themeFilesUpsert er en fuld overskrivning uden versionshistorik, og
   nw-kurv.js fylder 28 KB. Ved oprydningen (opgave 217) flyttes dette
   afsnit ind i nw-kurv.js, og afsnit 6 dér slettes. Indtil da kører begge:
   afsnit 6 låser varelisten og slipper for tidligt, men det sker under
   dækket og kan ikke ses. Dækket her styres af koden nedenfor alene. */
(function (w, d) {
  'use strict';

  var timer = null, t0 = 0, startAntal = 0, sidsteH = -1, stabil = 0, skiftet = false;
  var laastEl = null, daekEl = null, gemtRul = 0;
  var ankerVaelger = '', ankerTop = 0;

  function overdel() { return d.querySelector('cart-drawer .cart-drawer__content-upper'); }
  function ruller() { return d.querySelector('cart-drawer .cart-drawer__content'); }
  function antalVarer() { return d.querySelectorAll('cart-drawer .cart-item').length; }

  /* TEMAET SÆTTER SELV SKUFFENS SCROLL TIL 0. Målt 11/9 på 375 x 812, sporet
     billede for billede: ved t = 1256 ms, samtidig med at varelisten kortvarigt
     rummer tre varer, går scrollTop fra 362 til 0 MENS højden står fast på
     1105 px og scrollHeight stadig er 1105 mod en synlig højde på 620. Der er
     altså masser af plads at rulle i, så browseren har ikke klemt værdien, og
     en højdelås kan aldrig fange det. Det er temaets egen gentegning der
     ruller skuffen til toppen. DET er hoppet Mads ser.

     OG DEREFTER KLISTRER DEN TIL BUNDEN. Anden måling, efter at gendannelsen
     var på plads: fra t = 1191 til t = 1920 er scrollTop lig scrollHeight
     minus clientHeight i HVER eneste måling, 485, 539, 570, 593 ... 846,
     mens indholdet vokser fra 1105 til 1435 px. Skuffen bliver altså trukket
     med ned i bunden hele vejen. Derfor er én gendannelse undervejs ikke nok.

     TO GRADER: undervejs retter vi kun nulstillingen til 0, så vi ikke slås
     med en kunde der selv ruller. Til sidst forankrer vi.

     TIL SIDST FORANKRER VI PÅ BLOKKEN, IKKE PÅ TALLET. At sætte scrollTop
     tilbage til den gamle værdi er ikke nok, for der er kommet en varelinje
     ind OVER krydssalget. Målt: samme scrollTop, men krydssalget gled 276 px
     ned, og den knap kunden lige trykkede på flyttede sig fra y = 287 til
     y = 617 på en 812 px skærm. Det ville stadig ligne et hop.

     Derfor gemmer vi blokkens afstand til skærmens top ved klikket og
     genskaber PRÆCIS den afstand til sidst. Så bliver "Gør sættet færdigt"
     stående nøjagtig hvor den var, og kunden kan lægge den næste vare i uden
     at lede. Blokken slås op forfra på sin vælger, for temaets fletning kan
     have udskiftet noden undervejs. */
  function genskabRul(kunNul) {
    var s = ruller();
    if (!s) return;

    if (kunNul) {
      if (gemtRul <= 0 || Math.round(s.scrollTop) !== 0) return;
      var m1 = s.scrollHeight - s.clientHeight;
      s.scrollTop = gemtRul > m1 ? m1 : gemtRul;
      return;
    }

    var maal = s.scrollTop;
    var anker = ankerVaelger ? d.querySelector(ankerVaelger) : null;
    if (anker) {
      maal = s.scrollTop + (anker.getBoundingClientRect().top - ankerTop);
    } else if (gemtRul > 0) {
      maal = gemtRul;
    } else {
      return;
    }
    var maks = s.scrollHeight - s.clientHeight;
    if (maal < 0) maal = 0;
    if (maal > maks) maal = maks;
    s.scrollTop = maal;
  }

  function slip() {
    genskabRul(false);
    if (laastEl) { laastEl.style.minHeight = ''; laastEl = null; }
    /* Igen efter at låsen er sluppet: forsvinder minimumshøjden og indholdet
       er lavere end før, klemmer browseren scrollTop i samme ombæring. */
    genskabRul(false);
    if (daekEl) {
      var el = daekEl;
      daekEl = null;
      el.className = 'nw-opdat nw-opdat--ud';
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 260);
    }
    clearInterval(timer);
    timer = null;
  }

  /* TRY/CATCH ER IKKE PYNT. Under bygningen kaldte jeg ved en fejl en variabel
     som en funktion herinde. Hvert tik kastede, koden efter blev aldrig kørt,
     heller ikke nødbremsen, og dækket blev liggende over kurven for evigt.
     Det er den værst tænkelige udgang: kunden kan ikke se sin kurv. Går noget
     galt, slipper vi hellere for tidligt end slet ikke. */
  function tjek() {
    try { tjekIndre(); } catch (fejl) { slip(); }
  }

  /* FRIGIVELSEN HÆNGER PÅ ANTALLET AF VARER, IKKE PÅ HØJDEN.
     Første udgave af låsen (nw-kurv.js afsnit 6) slap når højden havde
     ændret sig og derefter stod stille. Højden gik 165 til 166 px, altså ét
     pixels afrunding, det talte som "noget skete", og låsen slap 300 ms
     senere, præcis inden det rigtige sammenfald. Antallet af .cart-item er
     det utvetydige signal om at temaets fletning faktisk er landet.
     Tolerancen på 2 px nedenfor findes af samme grund. */
  function tjekIndre() {
    var u = overdel();
    if (!u) return slip();
    genskabRul(true);
    var h = Math.round(u.scrollHeight);
    if (antalVarer() !== startAntal) skiftet = true;
    if (skiftet && Math.abs(h - sidsteH) <= 2) {
      if (!stabil) stabil = Date.now();
      else if (Date.now() - stabil > 400) return slip();
    } else {
      stabil = 0;
    }
    sidsteH = h;

    /* MISLYKKET TILFØJELSE SKAL IKKE KOSTE SEKS SEKUNDER.
       Efterprøvet 11/9 ved at lade /cart/add.js svare 422, som når en vare er
       udsolgt: antallet ændrer sig aldrig, skiftet bliver aldrig sandt, og
       dækket lå derfor i 6599 ms før nødbremsen tog det. Kunden stirrer på
       "Opdaterer kurven" i næsten syv sekunder og får så ingen forklaring.

       3500 ms er valgt ud fra målingen, ikke gættet: ved en tilføjelse der
       LYKKES skifter antallet efter 1118 til 1279 ms, altså med over to
       sekunders luft. Tager serveren længere tid end det, slipper vi for
       tidligt og kunden ser gentegningen som før, hvilket er det gamle
       problem og ikke et nyt. Det er den rigtige vej at fejle. */
    if (!skiftet && Date.now() - t0 > 3500) return slip();

    /* Nødbremse. Svarer serveren aldrig, slipper vi alligevel. */
    if (Date.now() - t0 > 6000) slip();
  }

  function start(knap) {
    if (daekEl) return;
    var u = overdel();
    if (!u) return;
    var h = Math.round(u.getBoundingClientRect().height);
    if (h <= 0) return;

    u.style.minHeight = h + 'px';
    laastEl = u;

    var s = ruller();
    gemtRul = s ? Math.round(s.scrollTop) : 0;

    ankerVaelger = '';
    ankerTop = 0;
    var blok = knap && knap.closest
      ? knap.closest('cart-drawer [data-merge="cross-sells"], cart-drawer #nw-gem-boks')
      : null;
    if (blok) {
      ankerVaelger = blok.id === 'nw-gem-boks'
        ? 'cart-drawer #nw-gem-boks'
        : 'cart-drawer [data-merge="cross-sells"]';
      ankerTop = blok.getBoundingClientRect().top;
    }

    /* DÆKKET HÆNGER PÅ SELVE SKUFFEN, IKKE PÅ INDHOLDET.
       Første forsøg lagde dækket inde i .cart-drawer__content-upper og regnede
       toppen ud fra .cart-drawer__header. Det så helt forkert ud på skærmen:
       overdelen er 1435 px høj og RULLER inde i .cart-drawer__content, som kun
       er 589 px. Målt mens skuffen var rullet ned: content-upper stod på
       top = -638 og hovedet på top = -623, altså begge oppe over skærmkanten.
       Dækket fulgte med derop og lagde sig hen over noget kunden ikke kunne se,
       mens det hun KUNNE se stod åbent.

       Skuffen selv, <cart-drawer>, er position:fixed og står på 0 til 812. Den
       er derfor holdepunktet.

       DÆKKET STOPPER VED BUNDBJÆLKEN, og det er den vigtige del: leveringsdato,
       besparelse, total, "Gå til betaling" og "Shop videre" ligger i
       .cart-drawer__footer og bliver stående og trykbare hele vejen igennem.
       Kunden er aldrig låst inde. Skærmen uden for skuffen lukker den også.
       Krydset i hjørnet er en anden sag: når kurven har varer, ligger det inde
       i det der ruller, og er i forvejen rullet væk (målt til top = -633). Det
       får alligevel et højere z-index i nw-opdat.css, så det ikke bliver dækket
       i de tilstande hvor det FAKTISK står på skærmen, fx den tomme kurv. */
    var skuffe = d.querySelector('cart-drawer');
    var fod = d.querySelector('cart-drawer .cart-drawer__footer');
    if (!skuffe) { laastEl = null; u.style.minHeight = ''; return; }
    var sR = skuffe.getBoundingClientRect();
    var bund = fod ? Math.round(sR.bottom - fod.getBoundingClientRect().top) : 0;
    if (bund < 0) bund = 0;

    /* INDTONINGEN LIGGER I CSS, IKKE I JS. Første udgave satte klassen
       nw-opdat--ud ved oprettelsen og fjernede den igen i et
       requestAnimationFrame, så browseren kunne nå at se startværdien.
       Det kørte aldrig: målt 300, 600, 800, 1500 og 2200 ms efter klikket
       stod klassen stadig på "nw-opdat nw-opdat--ud" og opacity på 0. Dækket
       var der, men usynligt, og hele opdateringen kunne ses lige igennem.
       En @keyframes-animation har sit eget startpunkt og kræver hverken et
       ekstra billede eller et kald der kan udeblive. */
    daekEl = d.createElement('div');
    daekEl.className = 'nw-opdat';
    daekEl.style.top = '0px';
    daekEl.style.bottom = bund + 'px';
    daekEl.setAttribute('role', 'status');
    daekEl.innerHTML =
      '<span class="nw-opdat__ring" aria-hidden="true"></span>' +
      '<span class="nw-opdat__tx">Opdaterer kurven</span>';
    skuffe.appendChild(daekEl);

    t0 = Date.now();
    startAntal = antalVarer();
    sidsteH = -1;
    stabil = 0;
    skiftet = false;
    if (!timer) timer = setInterval(tjek, 100);
  }

  /* KUN HANDLINGER DER LÆGGER I KURVEN. Ved sletning ville en gammel
     minimumshøjde holde kassen for høj i op til seks sekunder.
     INDFANGNINGSFASEN, fordi on:cart:add og on:cart:change IKKE fyrer på
     krydssalgets Tilføj. Efterprøvet med tællere: begge stod på 0. Knappen
     udsender dispatch:cart-drawer:refresh. */
  d.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var knap = e.target.closest('cart-drawer .nwxs-add__btn, cart-drawer .nw-gem__add');
    if (knap) start(knap);
  }, true);
}(window, document));
